<script setup lang="ts">
import { routerConstants } from '@/constants/routers/common'
import { useSharesActions } from '@/utils/shares'
import Image from '@/components/atoms/Image/index.vue'

const { PATH } = routerConstants.LOCATION
const sharesUrl = useSharesActions(PATH.QUESTIONS_INDEX, 'おすすめフォトグラファー')
</script>

<template>
  <div class="index-template">
    <div class="index-template-images index-template-images-left">
      <Image
        :path-pc="'/assets/images/questions/index-photographer-01.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-01.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-02.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-02.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-03.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-03.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-04.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-04.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-05.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-05.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-06.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-06.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-07.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-07.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-08.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-08.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-09.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-09.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-10.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-10.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-11.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-11.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-12.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-12.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
    </div>
    <div class="index-template-images-sp">
      <Image
        :path-pc="'/assets/images/questions/index-photographer-01.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-01.webp'"
        :img-class="'index-template-image'"
        :width-pc="75"
        :height-pc="75"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-03.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-03.webp'"
        :img-class="'index-template-image'"
        :width-pc="75"
        :height-pc="75"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-05.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-05.webp'"
        :img-class="'index-template-image'"
        :width-pc="75"
        :height-pc="75"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-07.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-07.webp'"
        :img-class="'index-template-image'"
        :width-pc="75"
        :height-pc="75"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-04.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-04.webp'"
        :img-class="'index-template-image'"
        :width-pc="75"
        :height-pc="75"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-24.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-24.webp'"
        :img-class="'index-template-image'"
        :width-pc="75"
        :height-pc="75"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-09.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-09.webp'"
        :img-class="'index-template-image'"
        :width-pc="75"
        :height-pc="75"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-02.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-02.webp'"
        :img-class="'index-template-image'"
        :width-pc="75"
        :height-pc="75"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-23.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-23.webp'"
        :img-class="'index-template-image'"
        :width-pc="75"
        :height-pc="75"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-16.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-16.webp'"
        :img-class="'index-template-image'"
        :width-pc="75"
        :height-pc="75"
        :is-lazy="false"
      ></Image>
    </div>
    <div class="index-template-content">
      <slot />
    </div>
    <div class="index-template-images index-template-images-right">
      <Image
        :path-pc="'/assets/images/questions/index-photographer-13.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-13.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-14.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-14.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-15.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-15.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-16.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-16.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-17.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-17.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-18.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-18.webp'"
        :img-class="'index-template-image'"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-19.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-19.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-20.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-20.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-21.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-21.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-22.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-22.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-23.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-23.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
      <Image
        :path-pc="'/assets/images/questions/index-photographer-24.jpg'"
        :path-pc-webp="'/assets/images/questions/index-photographer-24.webp'"
        :img-class="'index-template-image'"
        :width-pc="111"
        :height-pc="111"
        :is-lazy="false"
      ></Image>
    </div>
    <div class="index-template-share">
      <div class="index-template-share-title">診断結果をシェア</div>
      <div class="index-template-share-list">
        <a class="index-template-share-item" :href="sharesUrl.createFacebookShareUrl()" target="_blank">
          <img :src="'/assets/images/iconmonstr-facebook-4.svg'" alt="facebook" />
        </a>
        <a class="index-template-share-item" :href="sharesUrl.createTwitterShareUrl()" target="_blank">
          <img :src="'/assets/images/iconmonstr-twitter-4.svg'" alt="twitter" />
        </a>
        <a class="index-template-share-item" :href="sharesUrl.createLineShareUrl()" target="_blank">
          <img :src="'/assets/images/iconmonstr-line-4.svg'" alt="line" />
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/mixins/share' as share-mixins;
.index-template {
  position: relative;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-y: hidden;
  @media (max-width: 767px) {
    padding: 0 15px;
    justify-content: start;
  }
  &-content {
    width: 100%;
    max-width: 536px;
    margin-top: 30px;
    padding: 60px 85px;
    background-color: #fff;
    box-shadow: 0px 2px 6px #0000001f;
    border-radius: 4px;
    box-sizing: border-box;
    @media (max-width: 767px) {
      max-width: inherit;
      margin-top: 210px;
      padding: 40px 30px;
    }
  }
  &-images {
    position: absolute;
    display: grid;
    grid-auto-rows: minmax(110px, auto);
    grid-template-columns: 1fr 1fr;
    width: 15%;
    height: 100vh;
    @media (max-width: 767px) {
      display: none;
    }
    &-left {
      left: 0;
    }
    &-right {
      right: 0;
    }
    &-sp {
      display: none;
      @media (max-width: 767px) {
        position: absolute;
        top: 0;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        width: 100%;
        height: 75px;
      }
    }
  }
  &-share {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    @include share-mixins.sns-share-questions;
  }
}
:deep(.index-template-image) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
